import {
  asUtf8ToByteArray29u89fcaeh9ki as asUtf8ToByteArray,
  toUtf8Stringtpd5urkuirog as toUtf8String,
  ArrayIndexOutOfBoundsException3rm3ooo7dx3e8 as ArrayIndexOutOfBoundsException,
} from './NonJvmPlatform.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { charArray2ujmm1qusno00 as charArray } from '../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import {
  get_HEX_DIGIT_CHARSdv75g3vie5sw as get_HEX_DIGIT_CHARS,
  commonWrite1hq6d430w9jqm as commonWrite,
  access$codePointIndexToCharIndex$tByteStringKtwt7j9r87ekt2 as access$codePointIndexToCharIndex$tByteStringKt,
} from './internal/ByteString.mjs';
import {
  concatToString2syawgu50khxi as concatToString,
  substringiqarkczpya5m as substring,
} from '../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import {
  arrayRangeEquals1k0armei4gb4e as arrayRangeEquals,
  resolveDefaultParameter3hmb6x0gvzxi7 as resolveDefaultParameter,
} from './Util.mjs';
import {
  contentHashCode25jw6rgkgywwr as contentHashCode,
  copyOfRange3alro60z4hhf8 as copyOfRange,
} from '../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { replace3le3ie7l9k8aq as replace } from '../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        // Inline function 'kotlin.byteArrayOf' call
        var tmp$ret$0 = new Int8Array([]);
        tmp.s3w_1 = new (ByteString())(tmp$ret$0);
      }
      t3w(_this__u8e3s4) {
        // Inline function 'okio.internal.commonEncodeUtf8' call
        var byteString = new (ByteString())(asUtf8ToByteArray(_this__u8e3s4));
        byteString.u3w(_this__u8e3s4);
        return byteString;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var ByteStringClass;
function ByteString() {
  if (ByteStringClass === VOID) {
    class $ {
      constructor(data) {
        Companion_getInstance();
        this.z3u_1 = data;
        this.a3v_1 = 0;
        this.b3v_1 = null;
      }
      v3w(value) {
      }
      u3w(value) {
      }
      w3w() {
        // Inline function 'okio.internal.commonUtf8' call
        var result = this.b3v_1;
        if (result == null) {
          result = toUtf8String(this.x3w());
          this.u3w(result);
        }
        return result;
      }
      y3w() {
        // Inline function 'okio.internal.commonHex' call
        var result = charArray(imul(this.z3u_1.length, 2));
        var c = 0;
        var indexedObject = this.z3u_1;
        var inductionVariable = 0;
        var last = indexedObject.length;
        while (inductionVariable < last) {
          var b = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          var tmp1 = c;
          c = tmp1 + 1 | 0;
          var tmp = get_HEX_DIGIT_CHARS();
          // Inline function 'okio.shr' call
          result[tmp1] = tmp[b >> 4 & 15];
          var tmp2 = c;
          c = tmp2 + 1 | 0;
          var tmp_0 = get_HEX_DIGIT_CHARS();
          // Inline function 'okio.and' call
          result[tmp2] = tmp_0[b & 15];
        }
        return concatToString(result);
      }
      z3w(pos) {
        if (pos >= this.v2() || pos < 0)
          throw ArrayIndexOutOfBoundsException().j3w('size=' + this.v2() + ' pos=' + pos);
        // Inline function 'okio.internal.commonGetByte' call
        return this.z3u_1[pos];
      }
      w2(index) {
        return this.z3w(index);
      }
      v2() {
        return this.a3x();
      }
      a3x() {
        // Inline function 'okio.internal.commonGetSize' call
        return this.z3u_1.length;
      }
      b3x() {
        // Inline function 'okio.internal.commonToByteArray' call
        // Inline function 'kotlin.collections.copyOf' call
        // Inline function 'kotlin.js.asDynamic' call
        return this.z3u_1.slice();
      }
      x3w() {
        // Inline function 'okio.internal.commonInternalArray' call
        return this.z3u_1;
      }
      c3x(buffer, offset, byteCount) {
        return commonWrite(this, buffer, offset, byteCount);
      }
      d3x(offset, other, otherOffset, byteCount) {
        // Inline function 'okio.internal.commonRangeEquals' call
        return other.e3x(otherOffset, this.z3u_1, offset, byteCount);
      }
      e3x(offset, other, otherOffset, byteCount) {
        // Inline function 'okio.internal.commonRangeEquals' call
        return offset >= 0 && offset <= (this.z3u_1.length - byteCount | 0) && otherOffset >= 0 && otherOffset <= (other.length - byteCount | 0) && arrayRangeEquals(this.z3u_1, offset, other, otherOffset, byteCount);
      }
      i3v(prefix) {
        // Inline function 'okio.internal.commonStartsWith' call
        return this.d3x(0, prefix, 0, prefix.v2());
      }
      equals(other) {
        // Inline function 'okio.internal.commonEquals' call
        var tmp;
        if (other === this) {
          tmp = true;
        } else {
          if (other instanceof ByteString()) {
            tmp = (other.v2() === this.z3u_1.length && other.e3x(0, this.z3u_1, 0, this.z3u_1.length));
          } else {
            tmp = false;
          }
        }
        return tmp;
      }
      hashCode() {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonHashCode' call
          var result = this.a3v_1;
          if (!(result === 0)) {
            tmp$ret$0 = result;
            break $l$block;
          }
          // Inline function 'kotlin.also' call
          var this_0 = contentHashCode(this.z3u_1);
          this.v3w(this_0);
          tmp$ret$0 = this_0;
        }
        return tmp$ret$0;
      }
      f3x(other) {
        var tmp$ret$3;
        $l$block_0: {
          // Inline function 'okio.internal.commonCompareTo' call
          var sizeA = this.v2();
          var sizeB = other.v2();
          var i = 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var size = Math.min(sizeA, sizeB);
          $l$loop: while (i < size) {
            // Inline function 'okio.and' call
            var byteA = this.w2(i) & 255;
            // Inline function 'okio.and' call
            var byteB = other.w2(i) & 255;
            if (byteA === byteB) {
              i = i + 1 | 0;
              continue $l$loop;
            }
            tmp$ret$3 = byteA < byteB ? -1 : 1;
            break $l$block_0;
          }
          if (sizeA === sizeB) {
            tmp$ret$3 = 0;
            break $l$block_0;
          }
          tmp$ret$3 = sizeA < sizeB ? -1 : 1;
        }
        return tmp$ret$3;
      }
      d(other) {
        return this.f3x(other instanceof ByteString() ? other : THROW_CCE());
      }
      toString() {
        var tmp$ret$1;
        $l$block_1: {
          // Inline function 'okio.internal.commonToString' call
          // Inline function 'kotlin.collections.isEmpty' call
          if (this.z3u_1.length === 0) {
            tmp$ret$1 = '[size=0]';
            break $l$block_1;
          }
          var i = access$codePointIndexToCharIndex$tByteStringKt(this.z3u_1, 64);
          if (i === -1) {
            var tmp;
            if (this.z3u_1.length <= 64) {
              tmp = '[hex=' + this.y3w() + ']';
            } else {
              var tmp_0 = this.z3u_1.length;
              var tmp$ret$8;
              $l$block_0: {
                // Inline function 'okio.internal.commonSubstring' call
                var endIndex = resolveDefaultParameter(this, 64);
                // Inline function 'kotlin.require' call
                if (!(0 >= 0)) {
                  var message = 'beginIndex < 0';
                  throw IllegalArgumentException().s2(toString(message));
                }
                // Inline function 'kotlin.require' call
                if (!(endIndex <= this.z3u_1.length)) {
                  var message_0 = 'endIndex > length(' + this.z3u_1.length + ')';
                  throw IllegalArgumentException().s2(toString(message_0));
                }
                var subLen = endIndex - 0 | 0;
                // Inline function 'kotlin.require' call
                if (!(subLen >= 0)) {
                  var message_1 = 'endIndex < beginIndex';
                  throw IllegalArgumentException().s2(toString(message_1));
                }
                if (0 === 0 && endIndex === this.z3u_1.length) {
                  tmp$ret$8 = this;
                  break $l$block_0;
                }
                tmp$ret$8 = new (ByteString())(copyOfRange(this.z3u_1, 0, endIndex));
              }
              tmp = '[size=' + tmp_0 + ' hex=' + tmp$ret$8.y3w() + '\u2026]';
            }
            tmp$ret$1 = tmp;
            break $l$block_1;
          }
          var text = this.w3w();
          var safeText = replace(replace(replace(substring(text, 0, i), '\\', '\\\\'), '\n', '\\n'), '\r', '\\r');
          var tmp_1;
          if (i < text.length) {
            tmp_1 = '[size=' + this.z3u_1.length + ' text=' + safeText + '\u2026]';
          } else {
            tmp_1 = '[text=' + safeText + ']';
          }
          tmp$ret$1 = tmp_1;
        }
        return tmp$ret$1;
      }
    }
    initMetadataForClass($, 'ByteString', VOID, VOID, [Comparable()]);
    ByteStringClass = $;
  }
  return ByteStringClass;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance28gds36m4006o,
  ByteString as ByteString2qc03wzjsovk,
};
//endregion

//# sourceMappingURL=ByteString.mjs.map
